import { render, staticRenderFns } from "./index.vue?vue&type=template&id=28d8fa5a&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28d8fa5a')) {
      api.createRecord('28d8fa5a', component.options)
    } else {
      api.reload('28d8fa5a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=28d8fa5a&", function () {
      api.rerender('28d8fa5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/merchant/role/index.vue"
export default component.exports